<template>
 
<ui-button-options v-on:click.native.stop="viewAbsence()" :title="item.reason" :subtitle="computeSubtitle">
      
      <div slot="left"><ui-icon color="#666666" backgroundColor="transparent" class="email-icon" icon="thermometer"></ui-icon></div>


      <div slot="options" v-if="computeUserAccess">
       
        <ui-option title="language.edit" v-on:click.native.stop.prevent="edit_absence(item.id)" backgroundColor="#F2BC55" color="#FFFFFF" icon="pencil-alt"/>
        <ui-option title="language.report_fit_again" v-on:click.native.stop.prevent="delete_absence(item.id)" backgroundColor="rgb(140, 198, 62)" color="#FFFFFF" icon="thermometer"/>
       
      </div>
    
   </ui-button-options>
</template>

<script>
import UiButtonOptions from '../UiButtonOptions.vue';
import UiOption from '../UiOption.vue';
import UiIcon from '../UiIcon.vue';
import { USER_LEVEL } from '../../settings/USER_LEVEL.js';
import { mapState } from 'vuex';
import { helper } from '../../services/Helper.js';
import { absenceSettings } from '../../settings/AbsenceSettings.js';
    
export default {
  name: 'button-absence',
  props:{
    item:{default:{id:0}},
    download_id:{default:0},
  },
  data:function(){
    return {
      group_id:this.$route.params.id
    }
  },
  computed:{
    ...mapState([
       'appSettings','group'
      ]),
      computeSubtitle(){

        return absenceSettings.getDurationText(this.item.duration)
       
      },
      computeParentAccess(){
        if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return true;
         }else{
           return false
         }
      },
    computeUserAccess(){
      
        //var isInGlobal=(this.$router.currentRoute.path=='/documents');
        //if(!this.group.authorized && !isInGlobal ){
          // if we are in a group
         //  return false;
         //}
        
         if (this.appSettings.user_level==USER_LEVEL.NONE){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }
         return false;
        
    }
  },
  methods:{
    
    createSubtitle(item){
      if(item.absence){
        return item.date+' : '+this.createIntroText(item.description)
      }
      return undefined;
      
    },
    createIntroText(txt){
         return helper.getExcerpt(txt);
    },

    viewAbsence(){
      
       this.$router.push({path:'/group/'+this.group_id+'/absence/view/'+this.item.id})
      //this.$router.push({path:'/group/'+this.group_id+'/absence/add/'+encodeURIComponent(this.item.name)})
    /*
    if(this.item.absence){
      // already absent, just go to view
      this.$router.push({path:'/group/'+this.group_id+'/absence/view/'+this.item.id})
    }else{
      // add absence
      
    }
  */
   
     
    },
    
    formatDate(date){
      var year=date.getFullYear();
      var month=(date.getMonth()+101).toString().slice(-2);
      var day=(date.getDate()+100).toString().slice(-2);
      // set date?
      return year+"-"+month+"-"+day;

    },
    edit_absence(id){
     this.$router.push({path:'/group/'+this.group_id+'/absence/update/'+id})
    },
    delete_absence(id){
      
      // child is better
      var today=new Date();
      var date= this.formatDate(today)

      var payload={
          store_key:this.group_id+"absences",
          id:id,
          date:date,
          group_id:this.group_id, /* need this to reload for group */
        }

        // also this leads to reload -> dispatch get absences
        this.$store.dispatch('delete_absence',payload)
        
      },

    
  },
  mounted:function(){
    
  },
  components:{
    UiButtonOptions,
    UiOption,
    UiIcon,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.img-icon{
  display:block;
  height: 50px;
  width: 50px;
  border-radius: 9999px;
  border: 1px solid #707070;
}
</style>
